import * as React from 'react';
import { List, ListItem, ListItemText, Popover, Tooltip, Typography } from '@mui/material';
import { IB } from '../../../page/portal/setting/SettingPanel';
import { SystemUpdate } from '@mui/icons-material';

export default function CamelSystemPopover(props) {

    const { action, setCode } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'camelNotif-popover' : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const doAction = (script) => {
        if (action) action(script);
        handleClose();
    }

    return (
        <React.Fragment>
            <Tooltip title="Operações de Sistema">
                <IB
                    color='primary'
                    onClick={handleClick}
                    size="small"
                >
                    <SystemUpdate />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }} dense={true}>
                    <ListItem sx={{ cursor: 'pointer' }} onClick={() => doAction('camel-js-system-io.js')}>
                        <ListItemText
                            primary="Operação de IO"
                        />
                    </ListItem>
                    
                </List>
            </Popover>
        </React.Fragment>
    )
}